module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_01_770_280_en-94b53dcf17447b6b41b027831cd95d9c.jpg";